// Triggers a browser "Save As" for an already-fetched Blob/array-buffer
// response body. Centralizes the createObjectURL -> temporary <a> click ->
// revokeObjectURL dance so every download flow (invoice PDF, invoices zip,
// etc.) stays in sync instead of hand-rolling this per component.
export function triggerBlobDownload(data, filename, type) {
  const blob = data instanceof Blob ? data : new Blob([data], type ? { type } : undefined);
  const downloadUrl = window.URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.href = downloadUrl;
  link.download = filename;

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  window.URL.revokeObjectURL(downloadUrl);
}
